/**
 * TC - Enrollment Services v1.0.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

namespace Portico.Services.Legacy.EnrollmentService.Api {
/* tslint:disable:no-unused-variable member-ordering */
    import models = Portico.Models.Legacy;
    import Inject = Portico.Decorators.Inject;
    import Service =  Portico.Decorators.Service;

    @Service('app','VerifySurveyAnswerApi')
    @Inject('webServiceUrls', 'legacyService')
    export class VerifySurveyAnswerApi {
        private readonly instance: IServiceInstance;

        constructor(
            webServiceUrls: Portico.Models.Interfaces.IWebServiceUrls,
            legacyService: Portico.Services.LegacyService
        ) {
            this.instance = legacyService.createInstance(webServiceUrls.legacyEnrollment);
        }
        /**
        * 
        * @param programId 
        * @param surveyVerifyRequest 
        */
        public post (programId: number, surveyVerifyRequest: models.VerifySurveyEntryRequestModel) {
            const url = '/VerifySurveyAnswer/{programId}'
               .replace('{' + 'programId' + '}', String(programId));
            return this.instance.POST(models.ResponseModelVerifySurveyEntryResultModel, url, surveyVerifyRequest)
        }
    }
}